import { Navigate, useLocation } from "react-router-dom";
import { ROUTE_USER_LOGIN } from "../constants/route";
import { useDispatch } from "react-redux";
import { getItem } from "../helpers/cookies";
import { AUTH_TOKEN } from "../constants";
import { isTokenExpired } from "../helpers/general";
import { setErrorMsg } from "../slices/auth/login/reducer";
import { GetLoggedUser } from "../guard/admin";
import { userProfileAction } from "../slices/auth/login/action";
import { useEffect } from "react";

const AuthProtected = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const token = getItem(AUTH_TOKEN);

  const tokenExpired = isTokenExpired(token);
  const userInfo = GetLoggedUser();
  const { email } = userInfo;

  useEffect(() => {
    if (!email && token) {
      userProfileAction(dispatch);
    }
  }, [email, dispatch]);

  if (!token) {
    return <Navigate to={ROUTE_USER_LOGIN} state={{ from: location }} />;
  }

  if (tokenExpired) {
    dispatch(setErrorMsg("Your session expired, Please login again.!"));
    return <Navigate to={ROUTE_USER_LOGIN} state={{ from: location }} />;
  }

  return <>{props.children}</>;
};

export default AuthProtected;

// import { Navigate } from "react-router-dom";
// import { ROUTE_USER_LOGIN } from "../constants/route";
// import { useDispatch } from "react-redux";
// import { getItem } from "../helpers/cookies";
// import { AUTH_TOKEN } from "../constants";
// import { isTokenExpired } from "../helpers/general";
// import { setErrorMsg } from "../slices/auth/login/reducer";
// import { GetLoggedUser } from "../guard/admin";
// import { userProfileAction } from "../slices/auth/login/action";
// import { useEffect } from "react";

// const AuthProtected = (props) => {
//   const dispatch = useDispatch();
//   const token = getItem(AUTH_TOKEN);
//   if (!token) {
//     <Navigate
//       to={{ pathname: ROUTE_USER_LOGIN, state: { from: props.location } }}
//     />;
//   }

//   // if auth key expired
//   const tokenExpired = isTokenExpired(token);
//   if (tokenExpired) {
//     dispatch(setErrorMsg("Your session expired, Please login again.!"));
//     return (
//       <Navigate
//         to={{ pathname: ROUTE_USER_LOGIN, state: { from: props.location } }}
//       />
//     );
//   }

//   //get user info
//   const userInfo = GetLoggedUser();
//   const { email } = userInfo;

//   useEffect(() => {
//     if (!email) {
//       userProfileAction(dispatch);
//     }
//   }, [email, dispatch]);

//   return <>{props.children}</>;
// };
// export default AuthProtected;
